export const ORDER = "ORDER"; // 订单
export const SEARCH = "SEARCH"; // 搜索
export const HOME = "HOME"; // 首页
export const PRODUCT = "PRODUCT"; // 商详
export const USER_SETTING = "USER_SETTING"; // 用户中心-设置
export const COUPON = "COUPON"; // 优惠券
export const APPURL = "APPURL"; // 帮助中心 跳转app页面
export const LOGIN = "LOGIN"; // 登录
export const CREDIT = "CREDIT"; // 授信
export const CREDIT_EDIT = "CREDIT_EDIT"; // 授信-填写资料
export const CREDIT_VALIDE_CODE = "CREDIT_VALIDE_CODE"; // 授信-输入验证码
export const CREDIT_VALIDE_PHONE = "CREDIT_VALIDE_PHONE"; // 授信-验证手机号
export const CREDIT_VALIDE_ID = "CREDIT_VALIDE_ID"; // 授信-验证身份证，驾照等
export const CREDIT_RESULT = "CREDIT_RESULT"; // 授信-结果页
export const SHARE = "SHARE"; // 分享
export const EAMIL_LOGIN = "EAMIL_LOGIN"; // otp邮箱登录

export const ROUTER = {
  ORDER: "/order/list",
  SEARCH: "/search/search-page",
  HOME: "/main/home",
  PRODUCT: "/product/detail",
  USER_SETTING: "/user/setting",
  COUPON: "/user/coupon",
  APPURL: "",
  CREDIT: "/credit/main",
  CREDIT_EDIT: "/credit/edit",
  CREDIT_VALIDE_CODE: "/credit/valide-code",
  CREDIT_VALIDE_PHONE: "/credit/valide-phone",
  CREDIT_VALIDE_ID: "/credit/valide-ID",
  CREDIT_RESULT: "/credit/result",
  LOGIN: "/user/login",
  EAMIL_LOGIN: "/user/email-login",
};

/**
 * cookie的键
 */
export const COOKIE_KEYS_MAP = {
  CountryCode: "countryCode",
  CountryId: "countryId",
  LanguageCode: "languageCode",
  LanguageId: "languageId",
  previousSelectAddress: "detail_default_addressId",
  previousSelectAddressLabel: "detail_default_addressLabel",
  AcceptCookieKey: "accept_cookie",
};

export const M_USER_SERVICE = "M_USER_SERVICE";

// localStorage
export const LOCAL_STORAGE_KEYS = {
  creditEditData: "credit_edit_data",
};

// sessionStorage 切换国家会清理
export const SESSION_STORAGE_KEYS = {
  selectedAddress: "sil_selected_address",
  orderSettlementParamsCache: "sil_order_settlement_params_cache",
  placeOrderInfo: "sil_place_order_info",
  enterCreditRouterQuery: "enter_credit_router_query",
  creditBeginInfo: "credit_begin_info",
  creditPhoneNumber: "credit_phone_number",
  agreePolicy: "agree_policy",
  fourValideFailTip: "four_valide_fail_tip",
};

export const M_USER_EMAIL = "M_USER_EMAIL";

export const M_LOGIN_ORIGIN = "M_LOGIN_ORIGIN";

export const M_ADDRESS_COOKIE = "detail_default_addressId";

export const M_PWD_HISTORY_LENGTH = "M_PWD_HISTORY_LENGTH";

// 不需要登录态的页面
export const NO_LOGIN_ROUTER = [
  "/dev/ui",
  "/main/home",
  "/product/detail",
  "/search/search-page",
  "/search/result",
  "/user/login",
  "/user/register",
  "/user/register/SettingPassword",
  "/user/email-login",
  "/user/forgetPassword",
  "/user/forgetPassword/EnterPassword",
  "/user/email-validate",
  "/user/setting",
  "/user/security",
  "/user/legal-info",
  "/user/language",
  "/user/country",
  "/user/about-silvrr",
  "/_error",
  "/app-guide",
  "/product/evaluation",
];

export const DEFAULT_ADDRESS = {
  provinceId: 31,
  cityId: 32,
  districtId: 490,
  villageId: 0,
  provinceName: "Daerah Khusus Ibukota Jakarta",
  cityName: "Kota Jakarta Barat",
  districtName: "Cengkareng",
  villageName: "yy",
};
